import React, { PropsWithChildren } from "react";
import { motion } from "framer-motion";
import { TokenTransferToken } from "../..";

export type TokenTransferStepProps = {
  isShowing?: boolean;
  onSuccess?: ((data?: any) => Promise<void>) | ((data?: any) => void);
  onContinue?: (data?: any) => void;
  onError?: () => void;
  token?: TokenTransferToken;
  address?: string;
  userHasNumber?: boolean;
  transactionId?: string;
};

export default function TokenTransferStep({
  isShowing = false,
  children,
}: PropsWithChildren<TokenTransferStepProps>) {
  return (
    <StepTransition isShowing={isShowing}>
      <div className="flex flex-col gap-6 mt-5">{children}</div>
    </StepTransition>
  );
}

export function StepTransition({
  isShowing = false,
  children,
}: PropsWithChildren<TokenTransferStepProps>) {
  return (
    <>
      {isShowing && (
        <motion.div
          transition={{ duration: 0.5 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {children}
        </motion.div>
      )}
    </>
  );
}
